import {
  Box,
  Button,
  Card,
  CardContent,
  InputAdornment,
  Menu,
  MenuItem,
  SvgIcon,
  TextField,
} from "@mui/material";
import { RolesName } from "configs/roles";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useMemo, useState } from "react";
import { Search as SearchIcon } from "../../../components/icons/search";
import { useUserManagementUIContext } from "../UserManagementUIContext";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { initialFilter } from "../UserManagementUIHelpers";
// inital values form

const initialValues = {
  name: "",
};

const prepareFilter = (queryParams, values) => {
  const { name } = values;
  const newQueryParams = { ...queryParams };
  const filter = {
    paramsName: name,
  };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function UserManagementToolbar() {
  const userManagementUIContext = useUserManagementUIContext();
  const userManagementUIProps = useMemo(() => {
    return {
      queryParams: userManagementUIContext.queryParams,
      setQueryParams: userManagementUIContext.setQueryParams,
      goToCreateUser: userManagementUIContext.goToCreateUser,
    };
  }, [userManagementUIContext]);
  const { queryParams, setQueryParams, goToCreateUser } = userManagementUIProps;

  const handleFormSubmit = (values) => {
    const newQueryParams = prepareFilter(queryParams, values);
    if (!isEqual(newQueryParams, queryParams)) {
      setQueryParams(newQueryParams);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRoles = (roles) => {
    if (anchorEl) {
      if (roles === "") {
        setQueryParams(initialFilter);
      } else {
        let filter = {
          filter: {
            role: roles.toLowerCase(),
          },
          pageNumber: 1,
          pageSize: 500,
        };
        setQueryParams(filter);
      }
      setAnchorEl(null);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          m: -1,
        }}
      >
        <h1 className="pages-title">
          <u>Manajemen Pengguna</u>
        </h1>

        <Box sx={{ m: 1 }}>
          <Button color="primary" variant="contained" onClick={goToCreateUser}>
            Tambah Pengguna
          </Button>
        </Box>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Card>
          <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
            {({ handleSubmit, handleChange }) => (
              <form onSubmit={handleSubmit}>
                <CardContent
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ maxWidth: 500 }}>
                    <TextField
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SvgIcon color="action" fontSize="small">
                              <SearchIcon />
                            </SvgIcon>
                          </InputAdornment>
                        ),
                      }}
                      placeholder="Cari Nama Pengguna"
                      variant="outlined"
                      name="name"
                      onChange={handleChange}
                      autoComplete="off"
                    />
                  </Box>
                  <Box sx={{ m: 1 }}>
                    <Button
                      color="primary"
                      variant="contained"
                      onClick={handleClick}
                      startIcon={<FilterAltIcon />}
                      title="Filter Berdasarkan Status"
                    >
                      Status
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleClose}
                    >
                      <MenuItem onClick={() => handleRoles("")}>None</MenuItem>
                      <MenuItem
                        onClick={() => handleRoles(RolesName.ROLES_OPERATOR)}
                      >
                        {RolesName.ROLES_OPERATOR}
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleRoles(RolesName.ROLES_USER)}
                      >
                        {RolesName.ROLES_USER}
                      </MenuItem>
                    </Menu>
                  </Box>
                </CardContent>
              </form>
            )}
          </Formik>
        </Card>
      </Box>
    </Box>
  );
}
